"use client"

import { useAppContext } from "@/lib/context/app-context"
import Link from "next/link"
import { useParams } from "next/navigation"
import React, { MouseEventHandler } from "react"

/**
 * Use this component to create a Next.js `<LocalizedClientLink />` that persists the current country code in the url,
 * without having to explicitly pass it as a prop.
 */
const LocalizedClientLink = ({
  children,
  href,
  needLogin,
  ...props
}: {
  children?: React.ReactNode
  href: string
  className?: string
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined
  passHref?: true
  needLogin?: boolean
  [x: string]: any
}) => {
  const { locale } = useParams()
  let appContext = useAppContext()
  if (needLogin) {
    if (!appContext.user) {
      href = `/user?from=/${locale}${href}`
    }
  }

  return (
    <Link href={`/${locale}${href}`} {...props}>
      {children}
    </Link>
  )
}

export default LocalizedClientLink
